import { useContext, useEffect, useState } from "react";
import { BsFilter } from "react-icons/bs";
import { ProductContext } from "../../Contexts/ProductContext";
import { AuthContext } from "../../Contexts/AuthContext";
import { ProductCard } from "../../Component/ProductCard/ProductCard";
import "./ProductsStyle.css";
import { useLocation } from "react-router-dom";
import { buildProductEmpty, buildProductFilter, printDebugLog } from "../../Utils/utils.js";
import { LeftSideFilter } from "../global/LeftSideFilter.jsx";

const Products = () => {
  const {
    isLoading,
    productState,
    toggleShowFilters,
    getProducts,
    getMaxMinPriceFilter,
    getListWatchFilter
  } = useContext(ProductContext);
  const { setLoader } = useContext(AuthContext);

  const location = useLocation();

  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    printDebugLog("isLoading", isLoading);
    if (isLoading) {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [setLoader, isLoading]);

  useEffect(() => {
    printDebugLog("Products.jsx", "useEffect", "location.state", location.state);

    if (location.state && location.state?.catgId !== null) {
      getMaxMinPriceFilter([location.state.catgId._id]);
      const data = buildProductFilter([location.state?.catgId])
      getProducts(data);
    } else {
      getProducts(buildProductEmpty());
      getMaxMinPriceFilter([]);
    }
    getListWatchFilter();
  }, [location.state/*, getProducts, navigate, location.pathname*/]);

  useEffect(() => {
    printDebugLog("productState.products", productState.products, filteredProducts);
    if (productState?.products && productState?.products.length > 0) {
      setFilteredProducts(productState?.products);
    } else {
      setFilteredProducts([]);
    }

  }, [productState?.products]);


  return (
    <>
      {isLoading ? (
        ""
      ) : (
        <div className="products-page">
          <LeftSideFilter />
          <section className="display-products-list">
            <div className="products-list-header">
              <div className="heading-container">
                <button onClick={toggleShowFilters}>
                  <BsFilter className="showFilters-btn" />
                </button>
                <h2 className="heading">
                  Showing All Products({filteredProducts?.length || 0})
                </h2>
              </div>
              {filteredProducts.length === 0 && (
                <h1 className="empty-product-list">
                  Oops! Watches are currently out of stock in this category.
                </h1>
              )}
            </div>
            <div className="products-list-container">
              {filteredProducts.map((product) => (
                <ProductCard key={product.prdId} product={product} />
              ))}
            </div>
          </section>
        </div>

      )}
    </>
  );
};
export { Products };
